/* eslint-disable @typescript-eslint/no-empty-function */
import { WorldMapMarkerStory_worldMapView_markers } from 'graphql/query/__generated__/WorldMapMarkerStory';
import { WorldMapStories_publishedStoriesForWorldMap } from 'graphql/query/__generated__/WorldMapStories';
import { WorldMapView_worldMapView } from 'graphql/query/__generated__/worldMapView';
import { CustomMapConfig } from 'pages/custom/shared/CustomMapPage/types';
import { createContext, useRef, useState } from 'react';
import { MapRef } from 'react-map-gl';

export interface ICtxView {
    mapRef?: React.RefObject<MapRef>;
    map: WorldMapView_worldMapView;
    visibleMapSetIds?: string[];
    allDetails: WorldMapStories_publishedStoriesForWorldMap[];
    conectedDetails: WorldMapStories_publishedStoriesForWorldMap[];
    allMarkers: WorldMapMarkerStory_worldMapView_markers[];
    forceMarkersHighlight: boolean;
    setForceMarkersHighlight: (forceMarkersHighlight: boolean) => void;
    setMarkers: React.Dispatch<React.SetStateAction<WorldMapMarkerStory_worldMapView_markers[]>>;
    setAllDetails: (details: WorldMapStories_publishedStoriesForWorldMap[]) => void;
    setMap: (map: WorldMapView_worldMapView) => void;
    setVisibleMapSetIds: (visibleMapSetIds: string[]) => void;
    resetMap: () => void;
    customPageConfig: CustomMapConfig;
    setCustomPageConfig: (config: React.SetStateAction<CustomMapConfig>) => void;
    availableLanguages: string[];
}

export const CtxView = createContext<ICtxView>(null);

export const ViewStateProvider = ({ children }: { children: React.ReactNode }) => {
    const mapRef = useRef<MapRef | null>(null);
    const [map, setMap] = useState<WorldMapView_worldMapView>(null);
    const [visibleMapSetIds, setVisibleMapSetIds] = useState<string[]>([]);
    const [allDetails, setAllDetails] =
        useState<WorldMapStories_publishedStoriesForWorldMap[]>(null);
    const [allMarkers, setMarkers] = useState<WorldMapMarkerStory_worldMapView_markers[]>(null);
    const [forceMarkersHighlight, setForceMarkersHighlight] = useState(false);
    const [customPageConfig, setCustomPageConfig] = useState<CustomMapConfig>({});

    function resetMap() {
        console.log('Map reseted');
        setMap(null);
        setVisibleMapSetIds([]);
        setAllDetails(null);
        setMarkers(null);
        setForceMarkersHighlight(false);
        setCustomPageConfig({});
    }

    return (
        <CtxView.Provider
            value={{
                mapRef,
                map,
                setMap,
                visibleMapSetIds,
                setVisibleMapSetIds,
                allDetails,
                conectedDetails: allDetails?.filter((e) => e.connectedMarkers?.length) ?? [],
                setAllDetails,
                allMarkers,
                setMarkers,
                forceMarkersHighlight,
                setForceMarkersHighlight,
                resetMap,
                customPageConfig,
                setCustomPageConfig,
                availableLanguages: map?.guide?.availableLanguages ?? []
            }}
        >
            {children}
        </CtxView.Provider>
    );
};
